var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useUserInfo } from '@redbubble/next-provider';
import { useCallback } from 'react';
export var MatureContentToggle = function (_a) {
    var children = _a.children;
    var showMatureContent = useUserInfo()[0].showMatureContent;
    return children(showMatureContent);
};
export function useMatureContentToggle() {
    var _a = useUserInfo(), setUserInfo = _a[1];
    var memo = useCallback(function (showMatureContent) {
        fetch('/user-settings/mature-content', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                // Monolith API expects this boolean as text
                show: showMatureContent ? 'true' : 'false',
            }),
        });
        setUserInfo(function (userInfo) { return (__assign(__assign({}, userInfo), { showMatureContent: showMatureContent })); });
    }, [setUserInfo]);
    return memo;
}
